interface Delta {
  pct: number
  sign: 'up' | 'down' | 'flat'
  isPp?: boolean
}

interface Props {
  label: string
  value: string | number | undefined
  delta?: Delta
  loading?: boolean
}

export function KpiCard({ label, value, delta, loading }: Props) {
  return (
    <div className="kpi-card">
      <div className="kpi-label">{label}</div>
      <div className="kpi-value">
        {loading
          ? <span className="skeleton" style={{ display: 'inline-block', width: 80, height: 36 }} />
          : (value ?? '—')}
      </div>
      {delta && (
        <div className={`kpi-delta-pill ${delta.sign}`}>
          {delta.sign === 'up' ? '▲' : delta.sign === 'down' ? '▼' : '–'} {Math.abs(delta.pct).toFixed(0)}{delta.isPp ? 'pp' : '%'}
        </div>
      )}
    </div>
  )
}

export function pctDelta(curr?: number, prev?: number): Delta | undefined {
  if (curr === undefined || prev === undefined) return undefined
  if (prev === 0) {
    if (curr > 0) return { pct: 100, sign: 'up' }
    return { pct: 0, sign: 'flat' }
  }
  const d = ((curr - prev) / prev) * 100
  return { pct: d, sign: d > 1 ? 'up' : d < -1 ? 'down' : 'flat' }
}

export function ppDelta(curr?: number, prev?: number): Delta | undefined {
  if (curr === undefined || prev === undefined) return undefined
  const d = (curr - prev) * 100
  return { pct: d, sign: d > 0.1 ? 'up' : d < -0.1 ? 'down' : 'flat', isPp: true }
}
